<template>
	<div class="common-empty-state d-flex flex-column text-center justify-center align-center">
		<VImg
			ref="emptyStateImage"
			:alt="t('emptyState.title')"
			:src="image ?? emptyStateSvg"
			:height="imageHeight ?? '200px'"
			:width="imageWidth ?? '252px'"
		/>
		<div class="common-empty-state__title font-weight-semibold mt-4 mb-1 text-body-1 text-high-emphasis">
			<slot name="title">
				{{ title ?? t('emptyState.title') }}
			</slot>
		</div>
		<div class="common-empty-state__description text-body-2 text-medium-emphasis">
			<slot name="description">
				{{ description ?? t('emptyState.description') }}
			</slot>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import emptyStateSvg from '@/assets/image__empty_state.svg';

const { t } = useI18n();

defineProps<{
	image?: string;
	title?: string;
	description?: string;
	imageWidth?: string | number;
	imageHeight?: string | number;
}>();
</script>
